fragment productComparisonFragment on Product {
  _comparison: metafield(namespace: "oneworld", key: "comparison") {
    value
    type
  }
}
